/**
 * Read a theme CSS custom property's computed value off the document root.
 *
 * Charting libraries (lightweight-charts, Chart.js) take colors as plain
 * strings in JS config, so they can't use Tailwind utility classes. This
 * resolves a design token (e.g. `--color-up`) to its current value so charts
 * draw with the same palette as the rest of the app. Reads at call time, so
 * pass the token name and call it when (re)building the chart. Returns an empty
 * string outside a DOM (e.g. SSR / unit tests).
 *
 * @param name - The custom property name, including leading dashes (`--color-primary`).
 */
export function cssVar(name: string): string {
  if (typeof document === 'undefined') return '';
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}
